<template>
  <Modal :name="$options.name"
         @close="clearForm"
         :is-loading="isLoading"
         title="Megjegyzés">
    <template #body>
      <b-field label="Megjegyzés">
        <b-input v-model="form.comment"
                 type="textarea"></b-input>
      </b-field>
    </template>
    <template #footer>
      <b-button type="is-primary"
                @click="save">
        OK
      </b-button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modals/common/BasicModal'

export default {
  name: 'InspectionPlanCommentModal',
  components: {
    Modal,
  },
  data () {
    return {
      form: {
        comment: null,
      },
      isLoading: false,
    }
  },
  methods: {
    async save () {
      this.isLoading = true
      const response = await this.$store.dispatch('setInspectionPlanComment', {
        rowID: this.rowID,
        comment: this.form.comment,
      })
      if (response) {
        await this.updateRows(response)
        this.$store.dispatch('closeModal', this.$options.name)
        this.clearForm()
      }
      this.isLoading = false
    },
    clearForm () {
      this.form.comment = null
    },
  },
  computed: {
    // name () {
    //   return this.$store.state.modal.modalPayloadData[this.$options.name]?.name
    // },
    currentComment () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.currentComment
    },
    currentTableID () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.currentTableID
    },
    rowID () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.rowID
    },
    updateRows () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.updateRows
    },
  },
  watch: {
    currentComment: function (newVal, prevVal) {
      this.form.comment = newVal
    },
  },
}
</script>

<style scoped>

</style>
